import request from "../base/request";
import {applicationName} from "../utils";

let host = "/cm-sites-" + applicationName() + "/";

const Apis = {
  // 图集、视频、音频
  atlasList: host + "mediaFusion/list", //图集列表
  atlasColumnList: host + "appmanager/filterCheckedColumn", //图集获取栏目列表
  atlasAddToColumn: host + "mediaFusion/addToColumn", //图集获取添加至栏目数据
  delMediaFusion: host + "mediaFusion/delMediaFusion", //图集获取删除列表数据
  recallMediaFusion: host + "mediaFusion/recallMediaFusion", //图集获取撤回列表数据 
  editorColumnList: host + "dept/list", //编辑栏目列表
  getAllReport: host + "user/getAllReport", //获取个人数据
  atalsFilterColumn: host + "appmanager/filterCheckedColumn", //获取过滤栏目数据
  atalsFindbyid: host + "mediaFusion/findbyid", //获取点击编辑id数据
  atalsPublish: host + "mediaFusion/picture/publish", //图集发布
  // 专栏
  specialColumnList: host + "specialTopic/list", //获取专栏数据 
  specialColumnGetById: host + "specialTopic/getById", //获取点击专栏编辑
  specialColumnUpdate: host + "specialTopic/update", //获取保存专栏编辑
  specialColumnTopID: host + "specialTopic/changeTopById", //专栏置顶id 
  despecialColumnListID: host + "specialTopic/delete", //专栏删除id 
  addSpecialColumnstore: host + "specialTopic/add", //获取新增专栏保存数据
  specialColumnClick: host + "/ueditor/control", //获取点击上传数据
  // 粉丝管理
  fansmanagerList: host + "fansmanager/fans/list", //粉丝管理列表
  fansGroupList: host + "fansmanager/group/list", //粉丝分组数据
  fansGroupUpdate: host + "fansmanager/group/update", //粉丝重命名数据
  fansGroupDel: host + "fansmanager/group/del", //粉丝删除数据
  fansAddfanslist: host + "fansmanager/group/addfanslist", //粉丝管理加入分组
  fansDelfanslist: host + "fansmanager/group/delfanslist", //粉丝管理删除
  fansAddNodeFanslist: host + "fansmanager/group/add", //粉丝管理添加
  // 融媒号
  numberManagerList: host + "userCategory/getUserList", //融媒号管理列表
  numberGroupList: host + "userCategory/getUserCategoryList", //融媒号分组数据
  numberGroupUpdate: host + "userCategory/updateUserCategory", //融媒号重命名数据
  numberGroupDel: host + "userCategory/deleteUserCategory", //融媒号删除数据
  numberAddfanslist: host + "userCategory/userAddCategory", //融媒号管理加入分组
  numberDelfanslist: host + "userCategory/userDeleteCategory", //融媒号管理删除
  numberAddNodeFanslist: host + "userCategory/addUserCategory", //融媒号管理添加
  // 首页链接
  indexLinkList: host + "homepageUrl/list", //首页链接管理列表
  indexLinkListDelId: host + "homepageUrl/deleteById", //首页链接管理删除
  indexLinkListEdit: host + "homepageUrl/edit", //首页链接管理编辑
  // 消息推送
  messagePushList: host + "fansnotice/notice/list", //消息推送
  messagePushCheckedGroup: host + "fansmanager/group/fanslist", //消息推送选中分组
  messagePushAddToGroup: host + "fansnotice/notice/add", //消息推送添加至分组
  messagePushRecall: host + "fansnotice/notice/del", //消息推送撤回
};

// 图集、视频、音频
export const getAtlasList = (body, callBack) => {
  request({url:Apis.atlasList, method:"post", body, callBack});
};
export const getColumnList = (callBack) => {
  request({url:Apis.atlasColumnList, callBack});
};
export const addColumn = (body, callBack) => {
  request({url:Apis.atlasAddToColumn, body, callBack});
};
export const getDelId = (body, callBack) => {
  request({url:Apis.delMediaFusion, body, callBack});
};
export const getRecId = (body, callBack) => {
  request({url:Apis.recallMediaFusion, method:"post", body, callBack});
};
export const getEditorColumnList = (callBack) => {
  request({url:Apis.editorColumnList, callBack});
};
export const getAllReport = (callBack) => {
  request({url:Apis.getAllReport, callBack});
};
export const filterCheckedColumn = (body, callBack) => {
  request({url:Apis.atalsFilterColumn, method:"post", body, callBack});
};
export const getFindId = (callBack) => {
  request({url:Apis.atalsFindbyid, callBack});
};
export const getPublish = (body, callBack) => {
  request({url:Apis.atalsPublish, method:"post", body, callBack});
};

// 专栏
export const getSpecialColumnList = (body, callBack) => {
  request({url:Apis.specialColumnList, method:"post", body, callBack});
};
export const getEditId = (body, callBack) => {
  request({url:Apis.specialColumnGetById, method:"post", body, callBack});
};
export const getStoreData = (body, callBack) => {
  request({url:Apis.specialColumnUpdate, method:"post", body, callBack});
};
export const getSpecialColumnListID = (body, callBack) => {
  request({url:Apis.specialColumnTopID, method:"post", body, callBack});
};
export const deleteSpecialColumnListID = (body, callBack) => {
  request({url:Apis.despecialColumnListID, method:"post", body, callBack});
};
export const getAddColumn = (body, callBack) => {
  request({url:Apis.addSpecialColumnstore, method:"post", body, callBack});
};
export const clickUpLoad = (body, callBack) => {
  request({url:Apis.specialColumnClick, method:"post", body, callBack});
};

// 粉丝管理

export const fansManageList = (body, callBack) => {
  request({url:Apis.fansmanagerList, body, callBack});
};
export const getGroupList = (callBack) => {
  request({url:Apis.fansGroupList, callBack});
};
export const getRenameList = (body, callBack) => {
  request({url:Apis.fansGroupUpdate, body, callBack});
};
export const deleteRenameListId = (body, callBack) => {
  request({url:Apis.fansGroupDel, body, callBack});
};
export const addGroup = (body, callBack) => {
  request({url:Apis.fansAddfanslist, method:"post", body, callBack});
};
export const delGroup = (body, callBack) => {
  request({url:Apis.fansDelfanslist, method:"post", body, callBack});
};
export const addMenuNode = (body, callBack) => {
  request({url:Apis.fansAddNodeFanslist, method:"post", body, callBack});
};

// 融媒号管理
export const numberManageList = (body, callBack) => {
  request({url:Apis.numberManagerList, body, callBack});
};
export const getNumberGroupList = (callBack) => {
  request({url:Apis.numberGroupList, callBack});
};
export const getNumberRenameList = (body, callBack) => {
  request({url:Apis.numberGroupUpdate, body, callBack});
};
export const deleteNumberRenameListId = (body, callBack) => {
  request({url:Apis.numberGroupDel, body, callBack});
};
export const addNumberGroup = (body, callBack) => {
  request({url:Apis.numberAddfanslist, method:"post", body, callBack});
};
export const delNumberGroup = (body, callBack) => {
  request({url:Apis.numberDelfanslist, method:"post", body, callBack});
};
export const addNumberMenuNode = (body, callBack) => {
  request({url:Apis.numberAddNodeFanslist, method:"post", body, callBack});
};

// 首页链接
export const indexLinkList = (body, callBack) => {
  request({url:Apis.indexLinkList, body, callBack});
};
export const delList = (body, callBack) => {
  request({url:Apis.indexLinkListDelId, body, callBack});
};
export const editData = (body, callBack) => {
  request({url:Apis.indexLinkListEdit, method:"post", body, callBack});
};

// 消息推送
export const messagePush = (body, callBack) => {
  request({url:Apis.messagePushList, body, callBack});
};
export const getItemGroupList = (body, callBack) => {
  request({url:Apis.messagePushCheckedGroup, body, callBack});
};
export const getAddGroupList = (body, callBack) => {
  request({url:Apis.messagePushAddToGroup, method:"post", body, callBack});
};
export const getWithdrawGroupList = (body, callBack) => {
  request({url:Apis.messagePushRecall, body, callBack});
};
